import { CalibrationPointsConfig } from '../../sensors/types';

export const BASIC_FIELDS = ['BOL', 'AOL'] as const;
export type BasicField = typeof BASIC_FIELDS[number];

export const TEMPERATURE_FIELDS = ['roomT', 'roomF', 'highT', 'highTempF'] as const;
export type TemperatureField = typeof TEMPERATURE_FIELDS[number];

export type FieldMap = Record<string, string>;

export const createBasicFieldsObject = (): FieldMap => {
  return BASIC_FIELDS.reduce<FieldMap>((acc, field) => {
    acc[field] = "";
    return acc;
  }, {});
};

export const createTemperatureFieldsObject = (): FieldMap => {
  return TEMPERATURE_FIELDS.reduce<FieldMap>((acc, field) => {
    acc[field] = "";
    return acc;
  }, {});
};

export const clearCalibrationPointFields = (
  points: CalibrationPointsConfig,
  updates: FieldMap = {}
): FieldMap => {

  // Increasing points
  points.increasing.forEach(point => {
    const p = point.toString().replace(/\./g, '_');
    updates[`point_${p}_inc`] = "";
  });

  // Decreasing points
  points.decreasing.forEach(point => {
    if (Math.abs(point - 0) < 0.0001) {
      updates["point_0"] = "";
    } else {
      const p = point.toString().replace(/\./g, '_');
      updates[`point_${p}_dec`] = "";
    }
  });

  // Second increasing points
  points.secondIncreasing.forEach((point: number) => {
    const p = point.toString().replace(/\./g, '_');
    updates[`point_${p}_inc2`] = "";
  });

  return updates;
};
